module.exports = {["template-constructor-control-text_bius"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon" data-alt="Font Style" data-alt-pos="left" data-alt-offset="9"></div>\n\n	<div class="panel">\n		<div class="all-caps" title="All Caps"></div>\n		<div class="bold" title="Bold"></div>\n		<div class="italic" title="Italic"></div>\n		<div class="underline" title="Underline"></div>\n		<div class="strike" title="Strike"></div>\n	</div>\n';
}
return __p;
},}